import { render, staticRenderFns } from "./processed-payments.vue?vue&type=template&id=7c5a23b0&scoped=true"
import script from "./processed-payments.vue?vue&type=script&lang=js"
export * from "./processed-payments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5a23b0",
  null
  
)

export default component.exports